import { render, staticRenderFns } from "./TaskDisplay.vue?vue&type=template&id=4820cf0e&"
import script from "./TaskDisplay.vue?vue&type=script&lang=ts&"
export * from "./TaskDisplay.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports